export const DEFAULT_TIMEOUT = 6000
